export const getLiveShoppingProxy = () => {
  return {
    target: 'https://lcx-embed.bambuser.com',
    changeOrigin: true,
    pathRewrite: {
      [`^/live-shopping.js`]: '/about-you/embed.js',
    },
  };
};

export const getLiveShoppingPurchaseTrackingProxy = () => {
  return {
    target: 'https://cdn.liveshopping.bambuser.com',
    changeOrigin: true,
    pathRewrite: {
      [`^/live-shopping-purchase-tracking.js`]: '/metrics/bambuser.min.js',
    },
  };
};
